import { useState } from "react";
import { Box, Button, InputAdornment, TextField } from "@mui/material";
import { sendOtp, verifyOtp } from "../api/authService";
import { toast } from "react-toastify";
import { useAuth } from '../contexts/AuthContext'
import { useNavigate } from "react-router-dom";
const LoginPage = () => {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const [phone, setPhone] = useState('');
    const [error, setError] = useState(null);
    const [session_token, setSessionToken] = useState(null);
    const [loading, setLoading] = useState(false);
    const handleSendOtp = async (e) => {
        setError(null);
        setLoading(true);
        e.preventDefault();
        const formData = new FormData(e.target);
        const phone = formData.get('phone');
        try {
            const response = await sendOtp(phone);
            toast.success(response.message || 'OTP sent successfully');
            setStep(2);
            setPhone(phone);
            setSessionToken(response.data.session_token);
        } catch (error) {
            toast.error(error.message || 'Failed to send OTP');
            if (error?.data?.errors) {
                setError(error.data.errors ? error.data.errors : null);
            }
        }
        finally {
            setLoading(false);
        }
    }
    const handleResendOtp = async () => {
        setLoading(true);
        try {
            const response = await sendOtp(phone);
            toast.success(response.message || 'OTP sent successfully');
            setSessionToken(response.data.session_token);
        } catch (error) {
            toast.error(error.message || 'Failed to send OTP');
            if (error?.data?.errors) {
                setError(error.data.errors ? error.data.errors : null);
            }
        }
        finally {
            setLoading(false);
        }
    }
    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        setLoading(true);
        const formData = new FormData(e.target);
        const otp = formData.get('otp');
        try {
            const response = await verifyOtp(otp, session_token);
            toast.success(response.message || 'OTP verified successfully');
            console.log("Login response:", response);
            login(response.data.user, response.data.token);
            navigate('/');
        } catch (error) {
            toast.error(error.message || 'Failed to verify OTP');
            if (error?.data?.errors) {
                setError(error.data.errors ? error.data.errors : null);
            }
        }
        finally {
            setLoading(false);
        }
    }
    return (
        <Box sx={{ marginTop: 4, padding: '60px', textAlign: 'center', paddingTop: '0px', paddingBottom: '0px' }}>
            {step === 1 &&
                <form onSubmit={handleSendOtp} style={{ margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <TextField fullWidth id="phone" label="Phone" name="phone" variant="outlined"
                        error={!!error?.phone}
                        helperText={error?.phone}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        +91
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end" >
                                        <Button loading={loading}
                                            loadingPosition="start" type="submit" variant="contained">Send OTP</Button>
                                    </InputAdornment >
                                )
                            },
                        }} />
                </form>
            }
            {
                step === 2 &&
                <Box>
                    OTP sent to {phone} successfully.
                    not your number? <Button onClick={() => setStep(1)}>Change</Button>
                    <form onSubmit={handleVerifyOtp} style={{ margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <TextField id="otp" label="OTP" name="otp" variant="outlined" sx={{ marginTop: 2 }} error={!!error?.otp} helperText={error?.otp} />
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Button sx={{ justifySelf: 'flex-start', width: 'max-content' }} onClick={() => handleResendOtp()}>Resend Otp</Button>
                            <Button type="submit" variant="contained" sx={{ marginTop: 2, width: 'max-content', justifySelf: 'center' }}>Verify OTP</Button>
                        </Box>
                    </form>
                </Box>
            }

        </Box>
    );
}

export default LoginPage;